import { render, staticRenderFns } from "./OutlookLogo.vue?vue&type=template&id=4b0dcb06&"
import script from "./OutlookLogo.vue?vue&type=script&lang=js&"
export * from "./OutlookLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports